/* ============================================================
   TENUTA GRIECI · tg-funnel.js            20/08/2026
   Un intervento sul percorso d'acquisto. Non tocca tg-upgrades.js:
   questo file si innesta prima e lo pre-empta.

   Il criterio, dopo la revisione di Peppe: si toglie ATTRITO, non
   si aggiunge PRESSIONE. Tutto ciò che agisce DOPO che il cliente
   ha deciso è lecito; tutto ciò che lo sollecita PRIMA no — non su
   una scena che si guarda come un film.

   RIMOSSO 19/10/2026 — loader breve e iniezione di theme.js.
      Il loader non c'è più e theme.js si carica in defer dal layout.

   PRENOTA → CHECKOUT DIRETTO, CON LA QUANTITÀ SCELTA
      Con un articolo solo lo sheet chiedeva "checkout / carrello /
      continua a esplorare": una domanda con una risposta sola, perché
      a catalogo c'è una bottiglia. Intercettiamo il submit in fase di
      CAPTURE, prima del listener di tg-upgrades, e andiamo al checkout.

      17/10/2026 — /cart/add.js SOMMAVA la quantità a quella già nel
      carrello: chi sceglieva 6 bottiglie dopo averne provate 3 arrivava
      al checkout con 9. Ora /cart/update.js imposta per quella bottiglia
      esattamente la quantità scelta nella scheda (scelta rapida 3 · 6 ·
      12 o numero scritto a mano); le altre righe del carrello restano.

      19/10/2026 — La scheda può mandare una nota di riga (properties[…],
      es. "Pre-order: spedizione entro il 31 gennaio 2027"), che
      /cart/update.js non sa scrivere. Se c'è, si tolgono le righe di quella
      bottiglia e la si riaggiunge con /cart/add.js, nota compresa: la
      quantità resta quella scelta e la nota arriva a checkout ed email.

   RIMOSSO — barra d'acquisto fissa sulla home (.tg-homebar).
      Costruita il 20/08 e tolta lo stesso giorno: una pillola dorata
      fissa che segue lo scroll per dodici pannelli è un dispositivo da
      e-commerce di massa, incompatibile con una scena che si guarda.
      L'occasione d'acquisto resta dove è narrativamente sua: l'hero,
      il pannello edizione (data-buy), il blocco Gift, la sezione
      #purchase in fondo. Le regole .tg-homebar* in tg-fixes.css sono
      rimaste ma non agganciano più nulla: da togliere alla prossima
      modifica di quel file.
   ============================================================ */
(function(){
  'use strict';

  var CFG={};
  try{CFG=JSON.parse(document.getElementById('tg-routes').textContent)||{};}catch(e){CFG={};}
  var ROOT=(CFG.root||'/').replace(/\/$/,'');

  /* ---------- PRENOTA → CHECKOUT DIRETTO ---------- */
  /* Capture su document: precede il listener in bolla registrato da
     ajaxAtc() in tg-upgrades.js. stopImmediatePropagation lo disinnesca. */
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form||!form.classList||!form.classList.contains('product__form'))return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var btn=form.querySelector('[name="add"]');
    var prev=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='···';}

    var data=new FormData(form);
    var id=data.get('id');
    var qty=parseInt(data.get('quantity'),10);
    if(isNaN(qty)||qty<1)qty=1;
    var props={},hasProps=false;
    data.forEach(function(v,k){
      var m=/^properties\[(.+)\]$/.exec(k);
      if(m&&v){props[m[1]]=v;hasProps=true;}
    });

    function post(path,body){
      return fetch(ROOT+path,{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify(body)
      }).then(function(r){ if(!r.ok)throw new Error(path); return r.json(); });
    }
    function getCart(){
      return fetch(ROOT+'/cart.js',{headers:{'Accept':'application/json'}})
        .then(function(r){ if(!r.ok)throw new Error('cart'); return r.json(); });
    }

    var ready;
    if(!hasProps){
      var updates={}; updates[id]=qty;
      ready=post('/cart/update.js',{updates:updates});
    }else{
      ready=getCart()
        .then(function(cart){
          var clear={},any=false;
          (cart.items||[]).forEach(function(it){
            if(String(it.variant_id)===String(id)){clear[it.key]=0;any=true;}
          });
          return any?post('/cart/update.js',{updates:clear}):null;
        })
        .then(function(){ return post('/cart/add.js',{items:[{id:Number(id),quantity:qty,properties:props}]}); })
        .then(getCart);
    }

    ready
    .then(function(cart){
      var lines=(cart&&cart.items)?cart.items.length:1;
      /* Un'unica riga: non c'è nulla da comporre, si paga.
         Più righe (se un giorno il catalogo cresce): il carrello ha senso. */
      window.location.href = lines===1 ? (ROOT+'/checkout') : (CFG.cart||ROOT+'/cart');
    })
    .catch(function(){
      /* rete o endpoint KO: submit nativo, Shopify gestisce da sé */
      if(btn){btn.disabled=false;btn.textContent=prev;}
      HTMLFormElement.prototype.submit.call(form);
    });
  },true);
})();

/* ============================================================
   CURSORE → SCHEDA PRODOTTO                          23/10/2026
   Sopra i pannelli [data-explore] / [data-buy] il cursore dorato
   si allarga e dice "Discover" (o "Buy"), ma il clic non portava da
   nessuna parte (Buy scorreva fino a #purchase). Ora il clic sul
   pannello apre la scheda prodotto: l'etichetta mantiene la promessa.
   · vale solo dove il cursore esiste: mouse, senza reduced-motion
   · link, pulsanti, campi e moduli tengono il loro comportamento
   · trascinamenti e selezioni di testo non contano come clic
   · l'indirizzo è il primo link /products/ della pagina: nessun
     handle scritto a mano, se il prodotto cambia segue da solo
   ============================================================ */
(function(){
  'use strict';
  if(!window.matchMedia)return;
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  if(matchMedia('(hover:none),(pointer:coarse)').matches)return;
  if(location.pathname.indexOf('/products/')!==-1)return;

  var down=null;
  document.addEventListener('pointerdown',function(e){
    down={x:e.clientX,y:e.clientY};
  },true);

  document.addEventListener('click',function(e){
    if(e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    var t=e.target;
    if(!t||!t.closest)return;
    if(!t.closest('[data-explore],[data-buy]'))return;
    /* controlli veri: fanno quello che dicono */
    if(t.closest('a,button,input,select,textarea,label,summary,form,[role="button"],[role="link"]'))return;
    /* menu aperto, lente WebGL (cursore nascosto), trascinamento, testo selezionato */
    if(document.body.classList.contains('menu-open'))return;
    if(t.closest('.harvest26__glass')&&document.body.classList.contains('webgl-lens'))return;
    if(down&&(Math.abs(e.clientX-down.x)>6||Math.abs(e.clientY-down.y)>6))return;
    var sel=window.getSelection?String(window.getSelection()):'';
    if(sel.length>0)return;

    var a=document.querySelector('a[href*="/products/"]');
    var href=a&&a.getAttribute('href');
    if(!href)return;

    /* fase di capture su document: precede il listener di theme.js che
       su [data-buy] faceva scorrere a #purchase */
    e.stopPropagation();
    window.location.assign(href);
  },true);
})();

/* ============================================================
   SCENA ORIZZONTALE · CONTROLLO E RIMISURA              25/10/2026
   Sintomo: appena si entra sul sito lo scorrimento orizzontale a
   volte non funziona, e ricaricando la pagina si sistema.

   theme.js costruisce la scena una volta sola (build()) e in quel
   momento fissa la lunghezza dello scroll: end = scrollWidth della
   pista - larghezza della finestra, con start in cima a #scene.
   Se al primo accesso qualcosa cambia DOPO quel momento (un'immagine
   o un video che arriva, una barra del browser che compare, lo
   zoom, la barra di scorrimento, un ritorno indietro dalla cache),
   la misura resta quella vecchia e il pin non corrisponde più alla
   pista: la scena non scorre come dovrebbe. Al secondo accesso tutto
   è in cache, la pagina è già stabile quando build() misura, e per
   questo "ricaricando si aggiusta".

   Qui non si ricostruisce nulla: si CONTROLLA che la misura del pin
   coincida ancora con la pista e, se non coincide, si chiede a
   ScrollTrigger di rimisurare (invalidateOnRefresh è già attivo sul
   pin, quindi la lunghezza viene ricalcolata da zero). Il controllo
   gira nei primi secondi, quando finiscono i font e il caricamento,
   a ogni cambio di larghezza della pista e al ritorno indietro dalla
   cache. Se la misura è giusta non fa niente.

   Il controllo gira anche al primo gesto di scorrimento, che e' il
   momento in cui il problema si vedrebbe.

   In console: __tgSceneCheck() mostra lo stato della scena
   (lunghezza attesa, lunghezza del pin, differenza).

   Senza #track — tutte le pagine che non sono la home — non fa nulla.
   ============================================================ */
(function(){
  'use strict';
  var TOL=2, track=null, scene=null, timer=0, poll=0, guard=0;

  function pinST(){
    if(!window.ScrollTrigger||!ScrollTrigger.getAll)return null;
    var all=ScrollTrigger.getAll(),i;
    for(i=0;i<all.length;i++){ if(all[i].pin&&all[i].trigger===scene)return all[i]; }
    for(i=0;i<all.length;i++){ if(all[i].pin)return all[i]; }
    return null;
  }
  function state(){
    if(!track||!scene)return null;
    var st=pinST();
    var want=Math.max(0,track.scrollWidth-window.innerWidth);
    var have=st?(st.end-st.start):null;
    return {pin:!!st,expected:want,actual:have===null?null:Math.round(have),
            drift:have===null?null:Math.round(Math.abs(have-want)),
            trackWidth:track.scrollWidth,window:window.innerWidth};
  }
  function stale(){
    var s=state();
    return !!(s&&s.pin&&s.drift!==null&&s.drift>TOL);
  }
  function refresh(force){
    if(!force&&!stale())return false;
    try{ ScrollTrigger.refresh(); }catch(e){ return false; }
    try{ if(window.__lenis&&window.__lenis.resize)window.__lenis.resize(); }catch(e){}
    return true;
  }
  function check(ms){ clearTimeout(timer); timer=setTimeout(function(){ refresh(false); },ms||120); }

  function init(){
    track=document.getElementById('track');
    scene=document.getElementById('scene');
    if(!track||!scene)return;

    window.__tgSceneCheck=function(){ var s=state(); s.stale=stale(); return s; };

    /* i font sostituiti possono cambiare l'impaginazione dei pannelli */
    if(document.fonts){
      if(document.fonts.ready&&document.fonts.ready.then)document.fonts.ready.then(function(){ check(60); });
      if(document.fonts.addEventListener)document.fonts.addEventListener('loadingdone',function(){ check(60); });
    }
    /* immagini e video della scena finiscono dopo build() */
    if(document.readyState==='complete')check(200);
    else window.addEventListener('load',function(){ check(200); },{once:true});
    /* ritorno indietro dalla cache: misure vecchie */
    window.addEventListener('pageshow',function(e){ if(e.persisted)check(100); });
    /* cambio di larghezza della pista o di un pannello */
    if('ResizeObserver' in window){
      var ro=new ResizeObserver(function(){ check(150); });
      ro.observe(track);
      [].forEach.call(track.children,function(p){ ro.observe(p); });
    }
    /* primi 20 secondi: finestra in cui arrivano immagini, video e font */
    poll=setInterval(function(){ refresh(false); },700);
    setTimeout(function(){ clearInterval(poll); },20000);
    /* e comunque al primo gesto di chi guarda: e' il momento in cui il
       problema si vedrebbe. Al massimo un controllo ogni mezzo secondo. */
    ['scroll','wheel','touchmove','resize'].forEach(function(ev){
      window.addEventListener(ev,function(){
        var now=Date.now();
        if(now-guard<500)return;
        guard=now;
        refresh(false);
      },{passive:true});
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
